import { render } from "./PurchaseOrder_View.vue?vue&type=template&id=d5451bb6"
import script from "./PurchaseOrder_View.vue?vue&type=script&lang=js"
export * from "./PurchaseOrder_View.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__